import { useState } from "react"

export const usePhoneMask = () => {
  const [value, setValue] = useState("")

  const formatPhone = (input) => {
    let digits = input?.replace(/\D/g, "").slice(0, 9)

    let formatted = ""

    if (digits?.length > 0) {
      formatted += "(" + digits?.slice(0, 2)
    }
    if (digits?.length >= 3) {
      formatted += ") " + digits?.slice(2, 5)
    }
    if (digits?.length >= 6) {
      formatted += " " + digits?.slice(5, 7)
    }
    if (digits?.length >= 8) {
      formatted += " " + digits?.slice(7, 9)
    }

    return formatted
  }

  const handleChange = (e) => {
    const formatted = formatPhone(e.target.value)
    setValue(formatted)
  }

  return {
    value,
    onChange: handleChange,
    // setValue,
  }
}
